import { Autocomplete } from '@material-ui/lab';
import { TextInput } from '@room-match/shared-ui-components';
import shirtsize from 'data/new/ShirtSize.json';
import { FormikProps } from 'formik';
import React from 'react';
import { ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import CompCardButton from '../CompCardButton';
import { useStyles } from '../SizeCard.styles';

interface Props {
  form: FormikProps<ITalentUpdatePayload>;
  filterOptions: any;
  filteredShoeOptions: any[];
  filteredInseamOptions: any[];
  filteredNeckOptions: any[];
  sleeveOption: any[];
  filteredHatOptions: any[];
  filteredGloveOptions: any[];
  filteredBustOptions: any[];
  filteredKidShoeOptions: any[];
  compCardAdd?: (arg0: { key: string; value: string }) => void;
  compCardRemove?: (arg: { key: string }) => void;
}

const Common: React.FC<Props> = ({
  form,
  filteredInseamOptions,
  filteredNeckOptions,
  filterOptions,
  filteredShoeOptions,
  filteredHatOptions,
  filteredGloveOptions,
  sleeveOption,
  filteredBustOptions,
  filteredKidShoeOptions,
  compCardAdd,
  compCardRemove,
}) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      {/* {form.values.adult_minor === 'minor' ? (
        <div>
          <InputLabel id="labelCountry">Kids Shoe Size</InputLabel>
          <Autocomplete
            id="SC-kidsShoeSize"
            filterOptions={filterOptions}
            onChange={(e, newValue) => {
              form.setFieldValue('statistics.kid_shoe_size', newValue);
              form.handleChange(newValue);
            }}
            value={form.values.statistics?.kid_shoe_size}
            options={filteredKidShoeOptions}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            renderInput={(params) => (
              <TextInput
                {...params}
                placeholder={'Select Shoe Size'}
                errorMessage={!form.values.statistics?.kid_shoe_size ? 'Shoe size is required' : ''}
              />
            )}
          />
        </div>
      ) : (
        <div>
          <InputLabel id="labelCountry">Shoe Size</InputLabel>
          <Autocomplete
            id="SC-shoeSize"
            filterOptions={filterOptions}
            onChange={(e, newValue) => {
              form.setFieldValue('statistics.shoe_size', newValue);
              form.handleChange(newValue);
            }}
            value={form.values.statistics?.shoe_size}
            options={filteredShoeOptions}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            renderInput={(params) => (
              <TextInput
                {...params}
                placeholder={'Select Shoe Size'}
                errorMessage={!form.values.statistics?.shoe_size ? 'Shoe size is required' : ''}
              />
            )}
          />
        </div>
      )} */}
      {form.values.gender === 'Female' && form.values?.country !== 'Australia' ? (
        <div>
          <CompCardButton
            attributes={{
              label: 'Pants',
              key: 'pants_size',
            }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.pants_size !== '' && form.values.statistics?.pants_size !== null}
          />
          <Autocomplete
            filterOptions={filterOptions}
            onChange={(e, newValue, reason) => {
              if (compCardRemove && reason === 'clear') {
                compCardRemove({ key: 'pants_size' });
              }
              form.setFieldValue('statistics.pants_size', newValue);
            }}
            value={form.values.statistics?.pants_size}
            options={filteredBustOptions}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select Pants Size'}
              />
            )}
          />
        </div>
      ) : (
        <React.Fragment />
      )}
      {form.values?.country === 'Australia' ? (
        <>
          <div>
            <CompCardButton
              attributes={{
                label: 'Inseam',
                key: 'inside_leg',
              }}
              onClick={compCardAdd}
              hasValue={form.values.statistics?.inside_leg !== '' && form.values.statistics?.inside_leg !== null}
            />
            <Autocomplete
              id="SC-inseam"
              filterOptions={filterOptions}
              onChange={(e, newValue, reason) => {
                if (compCardRemove && reason === 'clear') {
                  compCardRemove({ key: 'inside_leg' });
                }
                form.setFieldValue('statistics.inside_leg', newValue);
              }}
              value={form.values.statistics?.inside_leg}
              options={filteredInseamOptions}
              getOptionSelected={(option, value) => option === value}
              fullWidth
              classes={{
                option: classes.option,
              }}
              renderInput={(params) => (
                <TextInput
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  placeholder={'Select Inside Leg'}
                />
              )}
            />
          </div>
          <div>
            <CompCardButton
              attributes={{
                label: 'Outseam',
                key: 'outside_leg',
              }}
              onClick={compCardAdd}
              hasValue={form.values.statistics?.outside_leg !== '' && form.values.statistics?.outside_leg !== null}
            />
            <Autocomplete
              filterOptions={filterOptions}
              onChange={(e, newValue, reason) => {
                if (compCardRemove && reason === 'clear') {
                  compCardRemove({ key: 'outside_leg' });
                }
                form.setFieldValue('statistics.outside_leg', newValue);
              }}
              value={form.values.statistics?.outside_leg}
              options={filteredInseamOptions}
              getOptionSelected={(option, value) => option === value}
              fullWidth
              classes={{
                option: classes.option,
              }}
              renderInput={(params) => (
                <TextInput
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  placeholder={'Select Outside Leg'}
                />
              )}
            />
          </div>
        </>
      ) : (
        <React.Fragment />
      )}
      <div>
        <CompCardButton
          attributes={{
            label: 'Neck Size',
            key: 'neck_size',
          }}
          onClick={compCardAdd}
          hasValue={form.values.statistics?.neck_size !== '' && form.values.statistics?.neck_size !== null}
        />
        <Autocomplete
          id="SC-neckSize"
          filterOptions={filterOptions}
          onChange={(e, newValue, reason) => {
            if (compCardRemove && reason === 'clear') {
              compCardRemove({ key: 'neck_size' });
            }
            form.setFieldValue('statistics.neck_size', newValue);
          }}
          value={form.values.statistics?.neck_size}
          options={filteredNeckOptions}
          getOptionSelected={(option, value) => option === value}
          fullWidth
          classes={{
            option: classes.option,
          }}
          renderInput={(params) => (
            <TextInput
              {...params}
              InputProps={{
                ...params.InputProps,
                classes: {
                  root: classes.textInputStyle,
                },
              }}
              placeholder={'Select Neck Size'}
            />
          )}
        />
      </div>
      <div>
        <CompCardButton
          attributes={{
            label: 'Sleeve Size',
            key: 'sleeves',
          }}
          onClick={compCardAdd}
          hasValue={form.values.statistics?.sleeves !== '' && form.values.statistics?.sleeves !== null}
        />
        <Autocomplete
          filterOptions={filterOptions}
          onChange={(e, newValue, reason) => {
            if (compCardRemove && reason === 'clear') {
              compCardRemove({ key: 'sleeves' });
            }
            form.setFieldValue('statistics.sleeves', newValue);
          }}
          value={form.values.statistics?.sleeves}
          options={sleeveOption}
          getOptionSelected={(option, value) => option === value}
          fullWidth
          classes={{
            option: classes.option,
          }}
          renderInput={(params) => (
            <TextInput
              {...params}
              InputProps={{
                ...params.InputProps,
                classes: {
                  root: classes.textInputStyle,
                },
              }}
              placeholder={'Select Sleeve Size'}
            />
          )}
        />
      </div>
      <div>
        <CompCardButton
          attributes={{
            label: 'T-Shirt Size',
            key: 'shirt_size',
          }}
          onClick={compCardAdd}
          hasValue={form.values.statistics?.shirt_size !== '' && form.values.statistics?.shirt_size !== null}
        />
        <Autocomplete
          id="SC-shirt"
          filterOptions={filterOptions}
          onChange={(e, newValue, reason) => {
            if (compCardRemove && reason === 'clear') {
              compCardRemove({ key: 'shirt_size' });
            }
            form.setFieldValue('statistics.shirt_size', newValue);
          }}
          value={form.values.statistics?.shirt_size}
          options={shirtsize.map((s) => s.value)}
          getOptionSelected={(option, value) => option === value}
          fullWidth
          classes={{
            option: classes.option,
          }}
          renderInput={(params) => (
            <TextInput
              {...params}
              InputProps={{
                ...params.InputProps,
                classes: {
                  root: classes.textInputStyle,
                },
              }}
              placeholder={'Select T-shirt Size'}
            />
          )}
        />
      </div>
      <div>
        <CompCardButton
          attributes={{
            label: 'Hat Size',
            key: 'hat',
          }}
          onClick={compCardAdd}
          hasValue={form.values.statistics?.hat !== '' && form.values.statistics?.hat !== null}
        />
        <Autocomplete
          id="SC-hatSize"
          filterOptions={filterOptions}
          onChange={(e, newValue, reason) => {
            if (compCardRemove && reason === 'clear') {
              compCardRemove({ key: 'hat' });
            }
            form.setFieldValue('statistics.hat', newValue);
          }}
          value={form.values.statistics?.hat}
          options={filteredHatOptions}
          getOptionSelected={(option, value) => option === value}
          fullWidth
          classes={{
            option: classes.option,
          }}
          renderInput={(params) => (
            <TextInput
              {...params}
              InputProps={{
                ...params.InputProps,
                classes: {
                  root: classes.textInputStyle,
                },
              }}
              placeholder={'Select Hat Size'}
            />
          )}
        />
      </div>
      <div>
        <CompCardButton
          attributes={{
            label: 'Glove Size',
            key: 'gloves',
          }}
          onClick={compCardAdd}
          hasValue={form.values.statistics?.gloves !== '' && form.values.statistics?.gloves !== null}
        />
        <Autocomplete
          id="SC-gloveSize"
          filterOptions={filterOptions}
          onChange={(e, newValue, reason) => {
            if (compCardRemove && reason === 'clear') {
              compCardRemove({ key: 'gloves' });
            }
            form.setFieldValue('statistics.gloves', newValue);
          }}
          value={form.values.statistics?.gloves}
          options={filteredGloveOptions}
          getOptionSelected={(option, value) => option === value}
          fullWidth
          classes={{
            option: classes.option,
          }}
          renderInput={(params) => (
            <TextInput
              {...params}
              InputProps={{
                ...params.InputProps,
                classes: {
                  root: classes.textInputStyle,
                },
              }}
              placeholder={'Select Glove Size'}
            />
          )}
        />
      </div>
      {form.values?.country !== 'Australia' ? (
        <>
          <div>
            <CompCardButton
              attributes={{
                label: 'Inseam',
                key: 'inside_leg',
              }}
              onClick={compCardAdd}
              hasValue={form.values.statistics?.inside_leg !== '' && form.values.statistics?.inside_leg !== null}
            />
            <Autocomplete
              id="SC-inseam"
              filterOptions={filterOptions}
              onChange={(e, newValue, reason) => {
                if (compCardRemove && reason === 'clear') {
                  compCardRemove({ key: 'inside_leg' });
                }
                form.setFieldValue('statistics.inside_leg', newValue);
              }}
              value={form.values.statistics?.inside_leg}
              options={filteredInseamOptions}
              getOptionSelected={(option, value) => option === value}
              fullWidth
              classes={{
                option: classes.option,
              }}
              renderInput={(params) => (
                <TextInput
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  placeholder={'Select Inside Leg'}
                />
              )}
            />
          </div>
          <div>
            <CompCardButton
              attributes={{
                label: 'Outseam',
                key: 'outside_leg',
              }}
              onClick={compCardAdd}
              hasValue={form.values.statistics?.outside_leg !== '' && form.values.statistics?.outside_leg !== null}
            />
            <Autocomplete
              filterOptions={filterOptions}
              onChange={(e, newValue, reason) => {
                if (compCardRemove && reason === 'clear') {
                  compCardRemove({ key: 'outside_leg' });
                }
                form.setFieldValue('statistics.outside_leg', newValue);
              }}
              value={form.values.statistics?.outside_leg}
              options={filteredInseamOptions}
              getOptionSelected={(option, value) => option === value}
              fullWidth
              classes={{
                option: classes.option,
              }}
              renderInput={(params) => (
                <TextInput
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  placeholder={'Select Outside Leg'}
                />
              )}
            />
          </div>
        </>
      ) : (
        <React.Fragment />
      )}
    </React.Fragment>
  );
};

export default Common;
